import React, { Component } from 'react';
import Request from '../../Request';
import Alert from '../../componentes/Alert';
import DetalhesProtocolo from './DetalhesProtocolo';
import Box from '../../componentes/Box';

class ConsultarProtocolo extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    // Bind de eventos dos componentes do formulario
    this.chaveAcessoChange = this.chaveAcessoChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  getInitialState() {
    return ({
      possuiErro: false
      , chaveAcesso: ''
      , protocolo: {}
    });
  }

  resetState() {
    this.setState(this.getInitialState());
    this.box.clearCallouts();
  }

  getRequestData() {
    return ({ chaveAcesso: this.state.chaveAcesso });
  }

  consultar() {
    this.box.toggleLoading(
      Request.post('protocolo/consultar/', this.getRequestData(), (protocolo) => {
        this.setState({
          protocolo: protocolo
          , chaveAcesso: ''
          , possuiErro: false
        }, this.box.toggleLoading);
      }, (error) => {
        this.box.toggleLoading();
        this.box.showCallout(error);
      })
    );
  }

  formSubmit(event) {
    this.box.clearCallouts();
    if (this.state.chaveAcesso.length >= 10) {
      this.setState({ protocolo: {} }, this.consultar);
    }
    event.preventDefault();
  }

  chaveAcessoChange(event) {
    let chaveAcesso = event.target.value;
    this.setState({ chaveAcesso: chaveAcesso });
    if (chaveAcesso.length < 10) {
      this.setState({ possuiErro: true });
    } else {
      this.setState({ possuiErro: false });
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <Box ref={(box) => { this.box = box; }} titulo="Consultar Protocolo">
              <form onSubmit={this.formSubmit}>
                <div className={'form-group ' + ((this.state.chaveAcesso.length > 0) ? (this.state.possuiErro ? 'has-error' : 'has-success') : '')}>
                  <label className="control-label">{this.state.chaveAcesso.length > 0 && (this.state.possuiErro ? <i className="fa fa-times-circle-o"></i> : <i className="fa fa-check"></i>)} Chave de acesso</label>
                  <input type="text" className="form-control" placeholder="Insira aqui a sua chave de acesso..." minLength="10" onChange={this.chaveAcessoChange} value={this.state.chaveAcesso} maxLength="40" autoFocus />
                  {(this.state.possuiErro && this.state.chaveAcesso.length > 0) && <span className="help-block">Chave de acesso não pode ser menor que 10 caracteres alfanuméricos</span>}
                </div>
                <div className="btn-group pull-right">
                  <button type="button" className="btn btn-default" onClick={this.resetState}>Limpar</button>
                  <button type="submit" className={'btn btn-primary ' + ((this.state.possuiErro || this.state.chaveAcesso.length === 0) ? 'disabled' : '')}>Consultar</button>
                </div>
              </form>
            </Box>
          </div>
        </div>
        <Box titulo="Protocolo" tipo="primary">
          {(this.state.protocolo.numero
            && <DetalhesProtocolo protocolos={[this.state.protocolo]} />)
            || <Alert title="Sem dados para exibir! Comece realizando uma nova consulta..." message="Consulta ainda não realizada ou não há nenhum protocolo para exibir com os filtros informados." />}
        </Box>
      </div >
    );
  }
}

export default ConsultarProtocolo;


// WEBPACK FOOTER //
// ./src/modulos/protocolo/consultar/ConsultarProtocolo.js